import { MainColor } from '../../palette/colors';

export const getRichTextEditorThemeConfig = () => {
  return {
    container: {
      borderColor: 'coolGrey30' as MainColor,
    },
    divider: {
      borderColor: 'coolGrey30' as MainColor,
    },
  };
};

export type RichTextEditorTheme = ReturnType<typeof getRichTextEditorThemeConfig>;
